import { render, staticRenderFns } from "./DeleteShippingAddressPopup.vue?vue&type=template&id=6ff40dc3&scoped=true"
import script from "./DeleteShippingAddressPopup.vue?vue&type=script&lang=js"
export * from "./DeleteShippingAddressPopup.vue?vue&type=script&lang=js"
import style0 from "./DeleteShippingAddressPopup.vue?vue&type=style&index=0&id=6ff40dc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff40dc3",
  null
  
)

export default component.exports